export default __webpack_public_path__ + "static/media/profile.a620ab81.svg";